import { TagVariant } from "@/components/Tag";

export const formatStatus = (status: string): string =>
  status.charAt(0).toUpperCase() + status.slice(1).replace(/_/g, " ");

// Semantic colour for a contract/signature status tag. Terminal "good" states are green,
// declined is red, everything in progress stays neutral.
export const statusVariant = (status: string): TagVariant => {
  if (status === "signed" || status === "executed" || status === "completed")
    return "success";
  if (status === "declined") return "danger";
  return "neutral";
};
